import Consts from "./Consts";

export const payWithPaydunya = {
    token: null,

    status: null,

    beforeToken: null,

    onToken: null,

    onFinish: null,

    onError: null,

    onClose: null,

    newQty: 0,
    newPercent: 0,

    receiptURL: null,

    data: {},

    launch(options={}) {
        const btn = document.createElement('button');
        btn.setAttribute('data-ref', Date.now().toString());
        btn.setAttribute('data-fullName', options.params?.fullName);
        btn.setAttribute('data-email', `${(options.params?.email || 'noemail@chooz.sarrux.ci')}&selected_scope=${options.params?.scope || 'ci'}`);
        btn.setAttribute('data-phone', '');
        btn.innerHTML = options.buttonHTML || '';

        payWithPaydunya.token = null;
        payWithPaydunya.status = null;
        payWithPaydunya.newQty = 0;
        payWithPaydunya.newPercent = 0;
        payWithPaydunya.receiptURL = null;

        window.PayDunya.setup({
            selector: window.$(btn),
            url: options.setupURL,
            method: options.setupMethod || 'GET',
            data: options.setupData || undefined,
            displayMode: window.PayDunya.DISPLAY_IN_POPUP,
            beforeRequest: function() {
                console.log('Before token');
                payWithPaydunya.beforeToken && payWithPaydunya.beforeToken();
            },
            onSuccess: function(token) {
                console.log('Token');
                payWithPaydunya.token = token;
                payWithPaydunya.onToken && payWithPaydunya.onToken(token);
            },
            onTerminate: function(ref, token, status) {
                console.log('Terminated');
                payWithPaydunya.status = status.toUpperCase();
                payWithPaydunya.onFinish && payWithPaydunya.onFinish(ref, token, payWithPaydunya.status);
            },
            onError: function (error) {
                console.log('Error');
                payWithPaydunya.onError && payWithPaydunya.onError({ message: error.toString() });
            },
            onUnsuccessfulResponse: function (jsonResponse) {
                console.log('Unsuccessful');
                payWithPaydunya.onError && payWithPaydunya.onError(jsonResponse);
            },
            onClose: function() {
                payWithPaydunya.onClose && payWithPaydunya.onClose();
            }
        }).requestToken();
    }
};
